module.exports = __webpack_public_path__ + "img/CreateTest.ac78ddc9.gif";